import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { whitelabelConfig } from '../../../config/whitelabel.config';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string[];
  image?: string;
  noindex?: boolean;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords = [],
  image,
  noindex = false,
}) => {
  const { t } = useTranslation();
  const config = whitelabelConfig.organizations[whitelabelConfig.activeOrganization];
  const siteTitle = config.organizationName;
  const defaultDescription = t('meta.homeDescription');
  const defaultImage = config.logo.light;

  const fullTitle = title ? `${t(title)} | ${siteTitle}` : siteTitle;
  const metaDescription = description ? t(description) : defaultDescription;
  const metaImage = image || defaultImage;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      {keywords.length > 0 && (
        <meta name="keywords" content={keywords.join(', ')} />
      )}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
      
      {/* Additional Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      {noindex && <meta name="robots" content="noindex" />}
      
      {/* Favicon - using the existing setup */}
      <link rel="icon" type="image/png" href="/logos/main-short-light.png" />
      <link rel="apple-touch-icon" href="/logos/main-short-light.png" />
    </Helmet>
  );
};

export default SEO; 